import { Copy, ShareFat } from '@phosphor-icons/react';
import { Button, Card } from '../components/ui';
import { useToast } from '../hooks/useToast';
import { useT } from '../i18n';
import { BOT_USERNAME } from '../lib/brand';
import { inviteLinks } from '../lib/invite';
import { copyText, haptic, openTelegramLink } from '../lib/tma';

/**
 * «Пригласить» (spec 6.1): share the bot link. Closed launch — the friend lands
 * on the waitlist. Without a bot username in the build, only the explanation.
 */
export function InvitePage() {
  const t = useT();
  const { toast, show } = useToast();
  const links = inviteLinks(BOT_USERNAME, t.invite.shareText);

  const copy = async () => {
    if (!links) return;
    if (await copyText(links.bot)) {
      haptic('success');
      show(t.invite.copied);
    } else {
      show(t.invite.copyFailed, 'warning');
    }
  };

  return (
    <div className="pt-2">
      <h1 className="text-xl font-extrabold mb-2">{t.invite.title}</h1>
      <p className="text-sm text-hint mb-4">{t.invite.text}</p>

      {links && (
        <Card variant="surface" padding="none" className="p-5">
          <p className="text-xs font-bold uppercase tracking-[0.06em] text-hint mb-1">{t.invite.linkLabel}</p>
          <p className="font-semibold break-all mb-4">{links.bot}</p>
          <div className="flex flex-col gap-2">
            <Button
              variant="primary"
              size="lg"
              fullWidth
              hapticKind={false}
              leftIcon={<ShareFat size={18} weight="fill" />}
              onClick={() => {
                haptic('light');
                openTelegramLink(links.share);
              }}
            >
              {t.invite.share}
            </Button>
            <Button variant="secondary" size="lg" fullWidth leftIcon={<Copy size={18} />} onClick={() => void copy()}>
              {t.invite.copy}
            </Button>
          </div>
        </Card>
      )}

      {toast}
    </div>
  );
}
